import {
  GET_ALL_ACTIVITIES,
  GET_ALL_TODO_PERFORMANCE_DATA,
  GET_ALL_ASSET,
  GET_ALL_ASSET_DATA,
  GET_ALL_BOOKING_DETAILS,
  GET_ALL_DOCUMENT,
  TODO_CHAT,
  GET_ALL_BOOKING_FILE_UPLOAD,
  SET_USER_LIST,
  GET_BOOKING_GROUPS,
  GET_SCAC_DATA,
  GET_BOOKING_REFERENCE_DATA,
  GET_ALL_TODO_DATA,
  GET_PERFORMANCE_INVENTORY_DATA,
  SET_ASSET_DATA_FOR_TRACKING,
} from "../constants";
import moment from "moment";
import { ApiCall } from "../../utils";
import { forEach } from "underscore";
import todo from "../reducers/todo";

// export const getAllActivities =
//   (activity_assignment_id, cb) => async (dispatch, getState) => {
//     try {
//       const {
//         auth: { token },
//       } = getState();

//       const result = await ApiCall.get(
//         `/todo_performance/${activity_assignment_id}`,
//         token
//       );
//       let allTodos = result.data[0].booking_todos;

//       const newTodoWithStatus = allTodos
//         .map((item) => {
//           if (item.estimated_time !== null) {
//             if (item.status === "pending") {
//               const check_date = moment().isAfter(item.estimated_time);
//               item.status = check_date ? "overdue" : "pending";
//             }
//           }
//           return item;
//         })
//         .filter((element) => element.estimated_time);

//       dispatch({
//         type: GET_ALL_ACTIVITIES,
//         payload: newTodoWithStatus,
//       });
//       dispatch({
//         type: GET_ALL_TODO_PERFORMANCE_DATA,
//         payload: result.data[0],
//       });
//       dispatch({ type: GET_ALL_ASSET, payload: result.data[0].assets });
//       //dispatch({ type: GET_ALL_ASSET_ENTRIES, payload:result.data.data[0].asset_entries })
//       dispatch({
//         type: GET_ALL_BOOKING_DETAILS,
//         payload: result.data[0].booking_data,
//       });
//       dispatch({
//         type: GET_ALL_DOCUMENT,
//         payload: result.data[0].documents,
//       });
//       dispatch(
//         getAssetList(
//           result.data[0].booking_assets,
//           result.data[0].asset_entries,
//           activity_assignment_id,
//           (res) => {}
//         )
//       );
//       dispatch({
//         type: GET_ALL_BOOKING_FILE_UPLOAD,
//         payload: result.data[0].booking_files,
//       });
//       cb(result);
//     } catch (error) {
//       cb(error);
//     }
//   };

const checkAssignedUser = (data, type, user_id, departments, collaborator_ids) => {

  if(type === "super-admin" || type === "admin"){
    return true;
  }
  if (data.user?.id === user_id) {
    return true;
  } else if (collaborator_ids?.includes(data?.collaborator_id)) {
    return true;
  } else if (data.department?.id && data.user === null && departments) {
    const result = departments.find((item) => item.department_id === data.department?.id);
    return result ? true : false;
  }
}

export const getAllActivities =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token, type, id, user_departments, collaborator_ids },
      } = getState();

      const result = await ApiCall.get(
        `/todo_performance/todo_list/${activity_assignment_id}`,
        token
      );
      let allTodos = result.data[0].booking_todos;
      let assignment = result.data[0];

      const newTodoWithStatus = allTodos
        .map((item) => {
          // if (item.estimated_time !== null) {
            if (item.status === "pending") {
              const check_date = moment().isAfter(item.estimated_time);
              item.status = check_date ? "overdue" : "pending";
            }
          // }
          return item;
        })
        .filter((element) => {
          let condition = true;
          // = element?.estimated_time;
          
          if(assignment?.show_assigned_todos){
            condition = checkAssignedUser(element, type, id, user_departments, collaborator_ids)
          }

          if(assignment?.show_trackable_todos && !condition){
            condition = element?.activity?.is_trackable === "1" ? true : false;
          }

          return condition;
        });

      dispatch({
        type: GET_ALL_ACTIVITIES,
        payload: newTodoWithStatus,
      });
      dispatch({
        type: GET_ALL_TODO_PERFORMANCE_DATA,
        payload: result.data[0],
      });
      dispatch({ type: GET_ALL_ASSET, payload: result.data[0].assets });
      //dispatch({ type: GET_ALL_ASSET_ENTRIES, payload:result.data.data[0].asset_entries })
      dispatch({
        type: GET_ALL_BOOKING_DETAILS,
        payload: result.data[0].booking_data,
      });
      // dispatch({
      //   type: GET_ALL_DOCUMENT,
      //   payload: result.data[0].documents,
      // });
      dispatch(
        getAssetList(
          result.data[0].booking_assets,
          result.data[0].asset_entries,
          activity_assignment_id,
          (res) => {}
        )
      );
      dispatch({
        type: GET_ALL_BOOKING_FILE_UPLOAD,
        payload: result.data[0].booking_files,
      });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getTodoPerformance =
  (activity_assignment_id, activity_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.get(
        `/todo_performance/list/${activity_assignment_id}/${activity_id}`,
        token
      );

      let todoPerformance = result.data[0].booking_todos[0];
      if (
        todoPerformance.estimated_time &&
        todoPerformance.status === "pending"
      ) {
        const check_date = moment().isAfter(todoPerformance.estimated_time);
        todoPerformance.status = check_date ? "overdue" : "pending";
      }

      if (result.data[0].inventory) {
        const inventoryData = {
          inventory: result.data[0].inventory,
          inventory_order_type: result.data[0].inventory_order_type,
          inventory_order_id: result.data[0].inventory_order_id,
        };
        dispatch({
          type: GET_PERFORMANCE_INVENTORY_DATA,
          payload: inventoryData,
        });
      }

      dispatch({ type: GET_ALL_TODO_DATA, payload: todoPerformance });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getTodoPerformanceFiles =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.get(
        `/todo_performance/files_list/${activity_assignment_id}`,
        token
      );
      let todoPerformanceFiles = result.data;
      dispatch({
        type: GET_ALL_DOCUMENT,
        payload: todoPerformanceFiles,
      });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getAssetList =
  (assetlist, assetEntry, activity_assignment_id, cb) =>
  async (dispatch, getState) => {
    const listData = [];
    if (assetEntry.length === 0) {
      assetlist.forEach((item) => {
        for (let i = 0; i < item.quantity; i++) {
          listData.push({
            id: Math.random(),
            asset_type: item.asset_type?.asset_type,
            activity_assignment_id,
            asset_name: "",
            remarks: item.remarks,
            booking_asset_id: item?.booking_asset_id,
          });
        }
      });
    }
    if (assetEntry.length !== 0) {
      let assetentries = [...assetEntry];
      assetlist.forEach((item) => {
        for (let i = 0; i < item.quantity; i++) {
          const check = assetentries.findIndex(
            (ele) => ele.asset_type === item.asset_type?.asset_type
          );
          if (check !== -1) {
            listData.push({
              id: Math.random(),
              completed: true,
              activity_assignment_id,
              remarks: item.remarks,
              booking_asset_id: item?.booking_asset_id,
              ...assetentries[check],
            });
            assetentries.splice(check, 1);
          } else {
            listData.push({
              id: Math.random(),
              asset_type: item.asset_type?.asset_type,
              activity_assignment_id,
              asset_name: "",
              remarks: item.remarks,
              booking_asset_id: item?.booking_asset_id,
              completed: false,
            });
          }
        }
      });
    }

    const assetTrackingData =
      assetEntry.length === 0
        ? listData
        : assetEntry.map((assetItem) => {
            const obj = {
              id: Math.random(),
              activity_assignment_id,
              ...assetItem,
            };
            return obj;
          });

    assetlist.forEach((element) => {
      const filterAsset = assetTrackingData.filter(
        (item) => item.asset_type === element.asset_type.asset_type
      );
      
      const remainingAssetQuantity =
        parseInt(element.quantity) - filterAsset.length;

      if (remainingAssetQuantity > 0) {
        for (let index = 0; index < remainingAssetQuantity; index++) {
          assetTrackingData.push({
            id: Math.random(),
            asset_type: element.asset_type?.asset_type,
            activity_assignment_id,
            booking_asset_id: element.booking_asset_id,
            asset_name: "",
          });
        }
      }
    });

    dispatch({ type: GET_ALL_ASSET_DATA, payload: listData });
    dispatch({ type: SET_ASSET_DATA_FOR_TRACKING, payload: assetTrackingData });
    cb(listData);
  };

export const assetEntryPerformance =
  (payload, request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.post("/assetentry", payload, token);
      request.onSuccess(result);
    } catch (error) {
      request.onError(error);
    }
  };

export const createTodoPerformance =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.postFormData(
        "/todo_performance",
        payload,
        token
      );
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const updateTodoPerformance =
  (payload, request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.patchFormData(
        "/todo_performance",
        payload,
        token
      );
      request.onSuccess(result);
    } catch (error) {
      request.onError(error);
    }
  };

export const deleteTodoPerformance =
  (payload, request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.post(
        "/todo_performance/delete/todo_performance",
        payload,
        token
      );
      request.onSuccess(result);
    } catch (error) {
      request.onError(error);
    }
  };

export const deleteUploadedFile =
  (activity_performance_file_upload_id, request) =>
  async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.delete(
        `/todo_performance/${activity_performance_file_upload_id}`,
        token
      );
      request.onSuccess(result);
    } catch (error) {}
  };

export const getChat =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { company, token },
      } = getState();

      const payload = {
        company_id: company.id,
        activity_assignment_id: activity_assignment_id,
      };

      const result = await ApiCall.post(
        "/chat/todo_performance",
        payload,
        token
      );
      dispatch({ type: TODO_CHAT, payload: result.data });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const createThread =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const payload = {
        activity_assignment_id: activity_assignment_id,
      };
      const result = await ApiCall.post(
        "/chatGroup/todo_performance/primary_group",
        payload,
        token
      );
      dispatch({ type: TODO_CHAT, payload: result.data });
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const downloadToDoPerformanceDocuments =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/todo_performance/downloads/${request.document_id}`,
        token
      );
      const blob = new Blob([result], { type: "application/octet-stream" });
      request.onSuccess(blob);
    } catch (error) {
      console.log("error while downloading documents", error);
    }
  };

export const getPerformanceSignedUrl =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/todo_performance/downloads/${request.document_id}`,
        token
      );
      request.onSuccess(result);
    } catch (error) {
      console.log("error while downloading documents", error);
    }
  };

export const getBookingSignedUrl = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(
      `/todo_performance/booking/downloads/${request.document_id}`,
      token
    );
    request.onSuccess(result);
  } catch (error) {
    console.log("error while downloading documents", error);
  }
};

export const getPublicLink = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(
      `/activityAssignment/public_link/${request.activity_assignment_id}`,
      token
    );
    request.onSuccess(result.data);
  } catch (error) {
    request.onError();
    console.log("error while getting publlic link --", error);
  }
};

export const getUserListForBooking =
  (activity_assignment_id) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/todo_performance/user_list/${activity_assignment_id}`,
        token
      );
      dispatch({ type: SET_USER_LIST, payload: result.data });
    } catch (error) {}
  };

export const createBookingGroup =
  (payload, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.post(
        "/chatGroup/todo_performance",
        payload,
        token
      );
      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getBookingGroups =
  (activity_assignment_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await ApiCall.get(
        `/chatGroup/todo_performance/booking_groups/${activity_assignment_id}`,
        token
      );

      dispatch({ type: GET_BOOKING_GROUPS, payload: result.data });

      cb(result);
    } catch (error) {
      cb(error);
    }
  };

export const getScacData = () => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get("/master/scac", token);
    dispatch({ type: GET_SCAC_DATA, payload: result.data });
  } catch (error) {}
};

export const addBookingReference = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(
      "/bookingReference",
      request.payload,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError(
      error.message
        ? error.message
        : "Something went wrong, please try again later."
    );
  }
};

export const getBookingReferenceList =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/bookingReference/${request.activity_assignment_id}`,
        token
      );
      dispatch({ type: GET_BOOKING_REFERENCE_DATA, payload: result.data });
    } catch (error) {
      request.onError(
        error?.message
          ? error.message
          : "Something went wrong, please try again later."
      );
    }
  };

export const deleteBookingReferenceItem =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.delete(
        `/bookingReference/${request.booking_reference_id}`,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError(
        error?.message
          ? error.message
          : "Something went wrong, please try again later."
      );
    }
  };

// API calling to GET Asset Tracking Data
export const getAssetTrackingData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(
      `/todo_performance/todo_performance_list/${request.activity_assignment_id}`,
      token
    );
    request.onSuccess(result);
  } catch (error) {
    request.onError();
  }
};


// GET API to get To Do Notification Data
export const getSendAsEmailToDoNotificationData =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/todo_notification/send_email/${request.todo_id}/${request.mappingid}`, token)
      request.onSuccess(result);
    } catch (error) {
      request.onError(error);
    }
};

export const sendTodoReminder =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/todo_performance/send_reminder/${request.activity_assignment_mapping_id}`, token)
      request.onSuccess(result);
    } catch (error) {
      request.onError(error);
    }
};

export const getTrackingData = (activity_assignment_id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/todo_performance/tracking_data/${activity_assignment_id}`, token)
    cb(result);
  } catch (error) {
    cb(error);
  }
};
